import { content } from '../data/content';
import { SectionHeading } from './ui/Ui';

/**
 * زاوية الألم: نُسمّي المشكلة بكلمات العميل نفسه قبل ذكر أي ميزة.
 *
 * كل موقف داخل بطاقة بيضاء بإطار أحمر متقطّع خفيف. المحاولات السابقة اعتمدت
 * على خطوط فاصلة وخيط عمودي وهالات — عناصر بسمك بكسل واحد لا تُرى فعلياً على
 * الجوال، فبقي النص طائراً على بياض بلا ما يحدّه. الإطار المتقطّع يحدّ البطاقة
 * بوضوح ويبقى أخفّ من الإطار المصمت، ولون واحد يجمع الشرطات وقرص الأيقونة.
 *
 * الترتيب أفقي: الأيقونة على الحافة والنص بجانبها، فيقصر ارتفاع البطاقة وتظهر
 * ثلاث بطاقات كاملة في أول شاشة بدل واحدة.
 */
export default function PainPoints() {
  return (
    <section id="problem" className="scroll-mt-16 md:scroll-mt-20 py-10 md:py-20 bg-white">
      <div className="container mx-auto">
        <SectionHeading
          eyebrow={content.painEyebrow}
          icon="fa-circle-question"
          iconColor="text-z-red"
          title={content.painTitle}
          highlight={content.painTitleHighlight}
          subtitle={content.painSubtitle}
        />

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 max-w-6xl mx-auto">
          {content.painItems.map((item) => (
            <div key={item.title} className="dash-card flex gap-4 bg-white p-4 md:p-5">
              {/* الأحمر الوحيد في البطاقة: أيقونة صغيرة على مربّع رمادي هادئ */}
              <span className="w-11 h-11 shrink-0 rounded-xl bg-z-light text-z-red flex items-center justify-center text-lg">
                <i className={`fa-solid ${item.icon}`} />
              </span>
              <div className="min-w-0">
                <h3 className="font-bold text-z-navy text-base md:text-lg leading-snug mb-1.5">{item.title}</h3>
                <p className="text-[13px] md:text-sm text-z-gray leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* الخلاصة تُقرأ كجملة مستقلة لا كبطاقة — الخط الأحمر تحتها يثبّتها في الذهن */}
        <p className="text-center text-xl md:text-3xl font-serif font-bold text-z-navy mt-10 md:mt-14">
          الحل بسيط…{' '}
          <span className="relative inline-block text-z-red">
            مكواة البخار العامودي من MATRXS
            {/* الخط يتلاشى من الطرفين بدل أن يبدأ وينتهي بحدّ قاطع — نفس لغة الفواصل في الموقع */}
            <span className="absolute -bottom-1 start-0 w-full h-0.5 rounded-full bg-gradient-to-l from-transparent via-z-red/60 to-transparent" />
          </span>
        </p>
      </div>
    </section>
  );
}
